const entitySchemaProperties = `
  actions,
  displayName,
  displayNamePlural,
  displayProperties,
  formCategories,
  dynamicProperties,
  extras,
  formProperties,
  id,
  identifier,
  interfaces,
  listingProperties,
  ownerProperty,
  properties,
  relations,
  required,
  userEditable
`;

const GET_ENTITY_SCHEMA = `
  query getEntitySchemas($identifier: String!) {
    getEntitySchemas(identifier: $identifier){
      ${entitySchemaProperties}
    }
  }
`;

const GET_PUBLISHED_CONTENT = `
  query {
    getEntitySchemas{
      id
      extras
    }
  }
`;

const GET_ALL_EDITABLE_ENTITYS_SCHEMA = `
  query getEntitySchemas($userEditable: Boolean = true) {
    getEntitySchemas(userEditable: $userEditable){
      ${entitySchemaProperties}
    }
  }
`;

const GET_ALL_ENTITY_SCHEMA = `
  query getEntitySchemas {
    getEntitySchemas{
      ${entitySchemaProperties}
    }
  }
`;

const GET_LISTING_DATA = `
query {
  getPages{
    id,
    name,
    content,
    published
  }
}
`;

const GET_ENTITY_URL = `
  query getRecordUrl($itemId: String!, $itemEntity: String!){
    getEntityUrl(itemId: $itemId, itemEntity: $itemEntity, fullUrl: true)
  }
`;

const GET_CURRENT_ENTITY = `
  query {
    currentEntity @client
    currentItemId @client
  }
`;

const GET_ITEM_LABEL = `
query getItemLabel($parent: JSON!, $collectionPropertyName: String!, $entityIdentifier: String!){
  getFormattedLabel(
        entityIdentifier: $entityIdentifier
        parent: $parent
        config: {
            collectionPropertyName:  $collectionPropertyName
        }
    )
}
`;

export {
  GET_ENTITY_SCHEMA,
  GET_ALL_EDITABLE_ENTITYS_SCHEMA,
  GET_ALL_ENTITY_SCHEMA,
  GET_LISTING_DATA,
  GET_ENTITY_URL,
  GET_CURRENT_ENTITY,
  GET_PUBLISHED_CONTENT,
  GET_ITEM_LABEL
};
